import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";

export default function AccessibilityStatusChart({
  currentIteration,
  issueMap,
  currentMap,
  setModalData,
  setShowModal,
  event,
  setImageUrl,
}) {
  const options = {
    title: "Accessibility Open, Resolved, Closed & Created Defects",
    titleTextStyle: { fontSize: "16" },
    hAxis: {
      slantedText: true,
      slantedTextAngle: 45,
      textStyle: { fontSize: 11 },
    },
    vAxis: { format: "#" },
    gridlines: { count: -1 },
    chartArea: { left: 70, top: 50, width: "65%", height: "65%" },
    tooltip: { isHtml: true },
  };

  const [dataTable, setDataTable] = useState([]);

  const getTooltip = function (statuses, date, name, values) {
    var tooltip =
      '<div align="left" style="width: auto; float: left; table-layout: auto">' +
      '<table class="table table-hover table-condensed table-sm" >' +
      "<thead><tr><th>" +
      date +
      "</th></tr></thead>" +
      "<tbody>";
    let index = 0;

    for (let statValue of statuses) {
      if (statValue === name) {
        tooltip =
          tooltip +
          '<tr class="table-danger" key={' +
          index +
          "}><td><b>" +
          name +
          "</b>";
      } else {
        tooltip = tooltip + "<tr  key={" + index + "}><td>" + statValue;
      }
      tooltip =
        tooltip +
        ": <b>" +
        Math.abs(values[statValue]?.length ? values[statValue].length : 0) +
        "</b></td></tr>";
      index++;
    }
    tooltip = tooltip + "</tbody></table></div>";

    return tooltip;
  };

  const chartEvents = [
    {
      eventName: "ready",
      callback: ({ chartWrapper, google }) => {
        var handler = async function () {
          const chart = chartWrapper.getChart();
          var selection = chart.getSelection();
          if (!selection || selection.length < 1) {
            return;
          }
          var row = selection[0].row;
          var col = selection[0].column;

          const data = [];
          let selected = null;
          let titleSelected = null;
          if (currentIteration === "Overall") {
            Object.keys(currentMap["Overall"]).forEach((date, index) => {
              if (index === row) {
                if (col === 1) {
                  selected = currentMap["Overall"][date]["Closed"];
                  titleSelected = "Closed";
                } else if (col === 3) {
                  selected = currentMap["Overall"][date]["Created"];
                  titleSelected = "Created";
                } else if (col === 5) {
                  selected = currentMap["Overall"][date]["Open"];
                  titleSelected = "Open";
                } else if (col === 7) {
                  selected = currentMap["Overall"][date]["Resolved"];
                  titleSelected = "Resolved";
                }
              }
            });
          } else {
            Object.keys(currentMap[currentIteration]).forEach((date, index) => {
              if (index === row) {
                if (col === 1) {
                  selected = currentMap["Overall"][date]["Closed"];
                  titleSelected = "Closed";
                } else if (col === 3) {
                  selected = currentMap["Overall"][date]["Created"];
                  titleSelected = "Created";
                } else if (col === 5) {
                  selected = currentMap["Overall"][date]["Open"];
                  titleSelected = "Open";
                } else if (col === 7) {
                  selected = currentMap["Overall"][date]["Resolved"];
                  titleSelected = "Resolved";
                }
              }
            });
          }

          selected.forEach((issue) => {
            const currentIssue = issueMap[issue];
            data.push({
              issueID: currentIssue.issueId,
              issueSummary: currentIssue.issueSummary,
              status: currentIssue.status,
              selfLink: currentIssue.link,
            });
          });

          setModalData({
            title: `Accessibility Defects - ${titleSelected}`,
            rows: data,
          });

          setShowModal(true);
        };

        google.visualization.events.addListener(
          chartWrapper.getChart(),
          "select",
          () => handler()
        );
      },
    },
  ];

  useEffect(() => {
    if (currentMap && currentIteration && Object.keys(currentMap).length > 0) {
      if (currentIteration === "Overall") {
        const currentDataTable = [];
        const header = ["Dates"];
        const columnArray = ["Closed", "Created", "Open", "Resolved"];
        for (var i = 0; i < columnArray.length; i++) {
          header.push(columnArray[i]);
          header.push({ type: "string", role: "tooltip", p: { html: true } });
        }
        currentDataTable.push(header);
        const dates = currentMap["Overall"];
        Object.keys(dates).forEach((date) => {
          const dateArray = [date];
          const currentElement = dates[date];
          dateArray.push(currentElement["Closed"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Closed", currentElement, false)
          );
          dateArray.push(currentElement["Created"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Created", currentElement, false)
          );
          dateArray.push(currentElement["Open"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Open", currentElement, false)
          );
          dateArray.push(currentElement["Resolved"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Resolved", currentElement, false)
          );
          currentDataTable.push(dateArray);
        });
        setDataTable(currentDataTable);
      } else {
        const currentDataTable = [];
        const header = ["Dates"];
        const columnArray = ["Closed", "Created", "Open", "Resolved"];
        for (var i = 0; i < columnArray.length; i++) {
          header.push(columnArray[i]);
          header.push({ type: "string", role: "tooltip", p: { html: true } });
        }
        currentDataTable.push(header);
        const dates = currentMap[currentIteration];
        Object.keys(dates).forEach((date) => {
          const dateArray = [date];
          const currentElement = dates[date];
          dateArray.push(currentElement["Closed"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Closed", currentElement, false)
          );
          dateArray.push(currentElement["Created"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Created", currentElement, false)
          );
          dateArray.push(currentElement["Open"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Open", currentElement["Open"], false)
          );
          dateArray.push(currentElement["Resolved"].length || 0);
          dateArray.push(
            getTooltip(columnArray, date, "Resolved", currentElement, false)
          );
          currentDataTable.push(dateArray);
        });
        setDataTable(currentDataTable);
      }
    }
  }, [currentMap, currentIteration]);

  if (event) {
    chartEvents.push({
      eventName: "ready",
      callback: ({ chartWrapper, google }) => {
        let url = chartWrapper.getChart().getImageURI();
        setImageUrl(url);
      },
    });
  }

  return (
    <div>
      {dataTable.length === 0 && (
        <div
          className="flex justify-center items-center h-96"
          style={{
            minHeight: "400px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <p className="text-gray-500">No data</p>
        </div>
      )}
      {dataTable.length > 0 && (
        <Chart
          chartType="LineChart"
          width="100%"
          height="400px"
          data={dataTable}
          options={options}
          chartEvents={chartEvents}
        />
      )}
    </div>
  );
}
